import Vue from 'vue'
import Router from 'vue-router'
import LoginView from './login.vue'
import RegisterView from './register.vue'
import ForgotView from './forgot.vue'
import ResetView from './reset.vue'
import ErrorView from './error.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      component: LoginView
    },
    {
      path: '/register',
      component: RegisterView,
      name: 'UpdateProfile',
      props: true
    },
    {
      path: '/forgot',
      component: ForgotView
    },
    {
      path: '/reset',
      component: ResetView
    },
    {
      path: '/error',
      component: ErrorView
    },
    {
      path: '/',
      component: LoginView
    },
    {
      path: '*',
      component: ErrorView
    }
  ]
})



// WEBPACK FOOTER //
// ./src/views/index.js